import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Table,
  TableContainer,
  ModalBody,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  VStack,
  useDisclosure,
  Input,
  HStack,
  useToast,
  Spinner,
  Image,
  Textarea,
  Switch,
} from "@chakra-ui/react";
import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../../context/AppContext";
import {
  AddCurrency,
  EditCurrency,
  EditUpi,
  GetAdminAllCurrency,
  GetUPI,
} from "../../../utils/api";
import Empty from "../../../components/Empty";
import CurrencyCard from "../components/CurrencyCard";

const Currency = () => {
  const { AdminToken } = useContext(AppContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  // Currencies
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currencyId, setCurrencyId] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [currentCurrency, setCurrentCurrency] = useState({
    currencyName: "",
    currencyPrice: "",
    color: "#000000",
    imgUrl: "",
  });

  // UPI
  const [upiModal, setUpiModal] = useState(false);
  const [upiData, setUpiData] = useState({});
  const [upiForm, setUpiForm] = useState({
    Token: "",
    upiId: "",
    imgURL: "",
    phonePayUpiId: "",
    phonePayImageUrl: "",
    isPhonePay: false,
    isInsta: false,
  });

  // Fetch Data
  useEffect(() => {
    setLoading(false);

    Promise.all([GetUPI(AdminToken), GetAdminAllCurrency(AdminToken)])
      .then(([upiRes, currencyRes]) => {
        setUpiData(upiRes.data.data);
        setUpiForm(upiRes.data.data);
        setCurrencies(currencyRes.data.currencies);
        setLoading(true);
      })
      .catch((err) => {
        console.error("Error fetching:", err);
        setLoading(true);
      });
  }, [AdminToken]);

  // Add Currency
  const handleAddCurrency = (e) => {
    e.preventDefault();

    if (!currentCurrency.currencyName || !currentCurrency.currencyPrice) {
      return toast({
        title: "Please fill all fields",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
    }

    AddCurrency(currentCurrency, AdminToken)
      .then((res) => {
        toast({
          title: "Currency Added Successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setCurrencies([...currencies, res.data.newCurrency]);
        onClose();
        setCurrentCurrency({ currencyName: "", currencyPrice: "", color: "#000000", imgUrl: "" });
      })
      .catch((err) => {
        toast({
          title: err.response?.data?.message || err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };

  // Edit Currency
  const handleEditCurrency = (e) => {
    e.preventDefault();

    EditCurrency(currencyId, currentCurrency, AdminToken)
      .then((res) => {
        toast({
          title: "Currency updated successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        setCurrencies((prev) =>
          prev.map((c) => (c._id === currencyId ? { ...c, ...currentCurrency } : c))
        );
        setEditModal(false);
      })
      .catch((err) => {
        toast({
          title: err.response?.data?.message || err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };

  const openEditModal = (id, currency) => {
    setCurrencyId(id);
    setCurrentCurrency(currency);
    setEditModal(true);
  };

  // Update UPI
  const handleUpiUpdate = (e) => {
    e.preventDefault();

    const { Token, upiId, imgURL, phonePayUpiId, phonePayImageUrl } = upiForm;

    if (!Token || !upiId || !imgURL || !phonePayUpiId || !phonePayImageUrl) {
      return toast({
        title: "Please fill all UPI fields",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
    }

    EditUpi(AdminToken, upiForm)
      .then(() => {
        toast({
          title: "UPI Updated Successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setUpiData(upiForm);
        setUpiModal(false);
      })
      .catch((err) => {
        toast({
          title: err.response?.data?.message || err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };

  const handleModeToggle = (checked) => {
    EditUpi(AdminToken, { isInsta: checked })
      .then(() => {
        setUpiForm((prev) => ({ ...prev, isInsta: checked }));
        toast({
          title: "Mode Updated Successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      })
      .catch((err) => {
        toast({
          title: err.response?.data?.message || err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };

  return (
    <VStack bg="white" p={["0.8rem 0.5rem", "1rem 1rem", "1.5rem"]} align="end" w="100%" minH="100vh" gap="1rem">
      <HStack>
        <Button colorScheme="red" onClick={onOpen}>
          Add Currency
        </Button>
        <Button colorScheme="red" onClick={() => setUpiModal(true)}>
          Edit UPI
        </Button>
      </HStack>

      {/* UPI Table */}
      <TableContainer w="100%" boxShadow="lg">
        <Table variant="simple" colorScheme="facebook">
          <Thead bg="rgb(229 60 94)">
            <Tr>
              <Th color="white">Mode</Th>
              <Th color="white">UPI Id Bharat</Th>
              <Th color="white">UPI Id Phone</Th>
              <Th color="white">Token</Th>
              <Th color="white">Bharat QR</Th>
              <Th color="white">Phone QR</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>
                <HStack>
                  <Text>Telegram</Text>
                  <Switch
                    isChecked={upiForm.isInsta}
                    onChange={(e) => handleModeToggle(e.target.checked)}
                    colorScheme="red"
                    size="sm"
                  />
                  <Text>Insta</Text>
                </HStack>
              </Td>
              <Td><Textarea value={upiData?.upiId} isDisabled size="sm" /></Td>
              <Td><Textarea value={upiData?.phonePayUpiId} isDisabled size="sm" /></Td>
              <Td><Textarea value={upiData?.Token} isDisabled size="sm" /></Td>
              <Td><Image src={upiData?.imgURL} w="7rem" h="7rem" /></Td>
              <Td><Image src={upiData?.phonePayImageUrl} w="7rem" h="7rem" /></Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>

      {/* Currency List */}
      {!loading ? (
        <Spinner size="xl" color="red.400" />
      ) : currencies.length ? (
        <TableContainer w="100%" boxShadow="lg">
          <Table variant="simple" colorScheme="facebook">
            <Thead bg="rgb(229 60 94)">
              <Tr>
                <Th color="white">Currency</Th>
                <Th color="white">Price</Th>
                <Th color="white">Color</Th>
                <Th color="white">Image</Th>
                <Th color="white">Edit</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currencies.map((c) => (
                <CurrencyCard
                  key={c._id}
                  id={c._id}
                  currencyName={c.currencyName}
                  currencyPrice={c.currencyPrice}
                  currencyColor={c.color || "red"}
                  img={c.imgUrl}
                  OpenBlockModal={() => openEditModal(c._id, c)}
                />
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      ) : (
        <Empty title="No currencies found!" />
      )}

      {/* UPI Modal */}
      {/* UPI Modal */}
      <Modal isOpen={upiModal} onClose={() => setUpiModal(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={handleUpiUpdate}>
              <VStack p="1rem" spacing="1rem">
                <Input
                  placeholder="UPI ID"
                  value={upiForm.upiId}
                  border="1.5px solid black"
                  onChange={(e) => setUpiForm({ ...upiForm, upiId: e.target.value })}
                />
                <Input
                  placeholder="Token"
                  value={upiForm.Token}
                  border="1.5px solid black"
                  onChange={(e) => setUpiForm({ ...upiForm, Token: e.target.value })}
                />

                {/* Bharat QR Image + Input */}
                <VStack w="full" spacing="0.5rem">
                  {upiForm.imgURL ? (
                    <Image
                      src={upiForm.imgURL}
                      alt="Bharat QR Preview"
                      boxSize="7rem"
                      border="1px solid #ccc"
                      objectFit="contain"
                    />
                  ) : (
                    <Text fontSize="sm" color="gray.500">No Bharat QR Preview</Text>
                  )}
                  <Input
                    placeholder="Bharat QR URL"
                    value={upiForm.imgURL}
                    border="1.5px solid black"
                    onChange={(e) =>
                      setUpiForm({ ...upiForm, imgURL: e.target.value })
                    }
                  />
                </VStack>

                {/* PhonePay QR Image + Input */}
                <VStack w="full" spacing="0.5rem">
                  {upiForm.phonePayImageUrl ? (
                    <Image
                      src={upiForm.phonePayImageUrl}
                      alt="PhonePay QR Preview"
                      boxSize="7rem"
                      border="1px solid #ccc"
                      objectFit="contain"
                    />
                  ) : (
                    <Text fontSize="sm" color="gray.500">No PhonePay QR Preview</Text>
                  )}
                  <Input
                    placeholder="PhonePay QR URL"
                    value={upiForm.phonePayImageUrl}
                    border="1.5px solid black"
                    onChange={(e) =>
                      setUpiForm({ ...upiForm, phonePayImageUrl: e.target.value })
                    }
                  />
                </VStack>

                {/* PhonePay UPI ID */}
                <Input
                  placeholder="PhonePay UPI ID"
                  value={upiForm.phonePayUpiId}
                  border="1.5px solid black"
                  onChange={(e) =>
                    setUpiForm({ ...upiForm, phonePayUpiId: e.target.value })
                  }
                />

                <Button type="submit" colorScheme="red" w="full">
                  Update UPI
                </Button>
              </VStack>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>


      {/* Currency Edit Modal */}
      <Modal isOpen={editModal} onClose={() => setEditModal(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={handleEditCurrency}>
              <VStack p="1rem" spacing="1rem">
                <Input placeholder="Currency Name" value={currentCurrency.currencyName}
                  border="1.5px solid black"
                  onChange={(e) => setCurrentCurrency({ ...currentCurrency, currencyName: e.target.value })} />
                <Input type="number" placeholder="Currency Price" value={currentCurrency.currencyPrice}
                  border="1.5px solid black"
                  onChange={(e) => setCurrentCurrency({ ...currentCurrency, currencyPrice: e.target.value })} />
                <Input type="text" placeholder="Image URL" value={currentCurrency.imgUrl}
                  border="1.5px solid black"
                  onChange={(e) => setCurrentCurrency({ ...currentCurrency, imgUrl: e.target.value })} />
                <Input type="color" value={currentCurrency.color}
                  onChange={(e) => setCurrentCurrency({ ...currentCurrency, color: e.target.value })} />
                <Button type="submit" colorScheme="red" w="full">Save</Button>
              </VStack>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Add Currency Modal */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={handleAddCurrency}>
              <VStack p="1rem" spacing="1rem">
                <Input placeholder="Currency Name"
                  value={currentCurrency.currencyName}
                  border="1.5px solid black"
                  onChange={(e) => setCurrentCurrency({ ...currentCurrency, currencyName: e.target.value })} />
                <Input type="number" placeholder="Currency Price"
                  value={currentCurrency.currencyPrice}
                  border="1.5px solid black"
                  onChange={(e) => setCurrentCurrency({ ...currentCurrency, currencyPrice: e.target.value })} />
                <Input type="text" placeholder="Image URL"
                  value={currentCurrency.imgUrl}
                  border="1.5px solid black"
                  onChange={(e) => setCurrentCurrency({ ...currentCurrency, imgUrl: e.target.value })} />
                <Input type="color" value={currentCurrency.color}
                  onChange={(e) => setCurrentCurrency({ ...currentCurrency, color: e.target.value })} />
                <Button type="submit" colorScheme="red" w="full">Add Currency</Button>
              </VStack>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </VStack>
  );
};

export default Currency;